var actions = {
	next: "Avanti",
	confirm: "Conferma",
	"continue": "Continua"
};
var errors = {
	unknown: "Si è verificato un errore sconosciuto",
	contactSupport: "Si è verificato un errore. Contatta l’assistenza.",
	tryAgain: "Si è verificato un errore. Riprova.",
	submit: "Si è verificato un errore durante l’invio."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Accedi con {name}",
	signupWith: "Iscriviti con {name}"
};
var alreadyHaveAccount = {
	company: "Hai già un account {company}?",
	text: "Sei già in possesso di un Streamlabs ID?",
	link: "Accedi"
};
var noAccount = {
	text: "Non ha ancora un account?",
	link: "Iscriviti"
};
var validation = {
	email: {
		invalid: "Inserisci un indirizzo e-mail valido"
	},
	password: {
		required: "È richiesta la password",
		min: "La password deve essere superiore a 8 caratteri",
		number: "La password deve contenere un numero",
		upper: "La password deve contenere un carattere maiuscolo",
		special: "La password deve contenere un carattere speciale"
	},
	username: {
		invalid: "Il nome deve essere composto da almeno 5 caratteri"
	},
	code: {
		minmax: "Il codice deve essere compreso tra 6 e 10 caratteri"
	}
};
var poweredBy = "Fornito da <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Azienda non trovata!",
		desc: "Riprova più tardi o contatta l'assistenza."
	},
	company: {
		logoAlt: "{company} Logo"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "Codice di autenticazione a 6 cifre/codice di backup a 8 cifre",
	successText: "Operazione completata correttamente! Reindirizzamento in corso...",
	remember: "Ricorda questo dispositivo per 30 giorni"
};
var createTfa = {
	scan: {
		title: "Abilita l’autenticazione a due fattori",
		lead: "Fai clic sul/copia o scansiona il codice riportato di seguito utilizzando la tua applicazione di autenticazione preferita. Si consiglia di utilizzare un'applicazione come <app0 />, <app1 /> o <app2 /> per memorizzare in modo sicuro i codici.",
		copied: "Copiato!",
		instructions: "In alternativa inserisci manualmente questo codice nell'app di autenticazione.",
		copy: "Copia il codice",
		proceed: "Conferma"
	},
	confirm: {
		title: "Conferma l'autenticazione a due fattori",
		lead: "Invia il codice di autenticazione a 2 fattori generato qui sotto per confermare e abilitare l'autenticazione a due fattori.",
		label: "Codice di autenticazione a 2 fattori (6 cifre)",
		verify: "Verifica il codice",
		next: "Operazione completata correttamente! Passaggio successivo"
	},
	save: {
		title: "Salva i vostri codici di recupero",
		lead: "Salva i codici di recupero forniti di seguito da utilizzare in caso di impossibilità di accesso all’autenticatore a 2 fattori. Dopo aver chiuso questa finestra di dialogo modale, i codici non saranno più disponibili.",
		label: "Codici di recupero",
		download: "Scarica i codici di recupero",
		copied: "Codici copiati!",
		finished: "Completato"
	}
};
var emailLoginForm = {
	buttonText: "Accedi",
	emailPlaceholder: "E-mail",
	passwordPlaceholder: "Password"
};
var emailSignupForm = {
	buttonText: "Iscriviti",
	emailPlaceholder: "Imposta un'e-mail",
	passwordPlaceholder: "Imposta una password",
	usernamePlaceholder: "Il tuo nome",
	ageLabel: "Data di nascita",
	agePlaceholder: "MM/GG/AAAA",
	agreeText: "Accetto i <terms>termini di servizio</terms> di Streamlabs e <privacy>l'informativa sulla privacy</privacy>.",
	agreeError: "Accetta i termini e le condizioni di Streamlabs"
};
var ageInput = {
	invalidDate: "Inserisci una data di nascita valida",
	futureDate: "La data di nascita deve essere passata",
	minDate: "Le date precedenti all'anno {year} non sono consentite",
	minAge_one: "Per utilizzare Streamlabs devi avere almeno {years} anno",
	minAge_two: "Per utilizzare Streamlabs devi avere almeno {years} anni",
	minAge_other: "Per utilizzare Streamlabs devi avere almeno {years} anni"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mail",
	back: "Torna all’accesso",
	successText: "Operazione completata correttamente! Ti abbiamo inviato un codice di reimpostazione della password",
	buttonText: "Richiedi la reimpostazione dell'e-mail",
	create: {
		successText: "Operazione completata correttamente! Per iniziare, ti abbiamo inviato un codice di verifica.",
		buttonText: "Richiedi il codice di verifica"
	},
	errors: {
		notFound: "Nessun account trovato per questo indirizzo e-mail"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Hai dimenticato la password?",
	lead: "Se hai bisogno di reimpostare la password, inserisci il vostro indirizzo e-mail qui sotto e vi invieremo un'e-mail per avviare la procedura.",
	resetTitle: "Reimposta la password",
	resetLead: "Dovresti aver ricevuto un codice via e-mail. Completa il modulo per reimpostare la password.",
	create: {
		title: "Crea la tua password",
		lead: "Congratulazioni per aver creato il tuo ID Streamlabs. Ancora un passaggio e potrai effettuare l’accesso ovunque in Streamlabs!",
		resetTitle: "Scegli una password",
		resetLead: "Dovresti aver ricevuto un codice via e-mail. Usalo e completa il modulo per impostare la tua password."
	},
	successText: "Operazione completata correttamente! Reindirizzamento in corso...",
	signInTitle: "Sei già in possesso di un account?",
	signInBtn: "Accedi"
};
var checkTfaCard = {
	title: "Verifica l’autenticazione a due fattori",
	lead: "Immetti un codice di autenticazione a 2 fattori per continuare.",
	successText: "2FA confermato correttamente!",
	back: "Indietro"
};
var verifyEmailCard = {
	title: "Verifica l'e-mail",
	lead: "Controlla il codice a 8 cifre ricevuto via e-mail da Streamlabs e inseriscilo qui sotto.",
	back: "Indietro",
	successText: "E-mail verificata correttamente."
};
var upgradeCard = {
	confirm: {
		title: "Conferma connessione con {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Le prossime volte potrai accedere a {company} con l’e-mail e la password fornite.",
			"Puoi accedere a tutti gli altri prodotti da Streamlabs con il tuo ID e connettere altri account esistenti, se ne sei in possesso.",
			"Questa modifica non influirà sul tuo account {company}."
		],
		button: "Conferma",
		cancel: "Annulla",
		switchAccount: "Cambia account",
		success: "Connessione in corso..."
	},
	confirmed: {
		title: "Operazione completata correttamente!",
		subtitle: "Il tuo Streamlabs ID è stato creato e il tuo account {company} è connesso.",
		text: "Puoi utilizzare il tuo Streamlabs ID per tutti i prodotti Streamlabs. Se disponi di account esistenti, puoi connetterli a questo ID da ciascuna app.",
		button: "Chiudi"
	},
	error: {
		user: "Identificazione utente non riuscita. Riprova o contatta l'assistenza."
	}
};
var confirmCard = {
	confirm: {
		title: "Conferma connessione con {company}",
		subtitle: "Abbiamo trovato un account con un'e-mail corrispondente. Vuoi unire questo account con Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Potrai accedere a {company} con l’e-mail e la password fornite tramite Streamlabs ID.",
			"Puoi accedere a tutti gli altri prodotti da Streamlabs con il tuo ID e connettere altri account esistenti, se ne sei in possesso.",
			"Questa modifica non influirà sul tuo account."
		],
		button: "Conferma",
		cancel: "Annulla",
		switchAccount: "Cambia account",
		success: "Connessione in corso..."
	},
	confirmed: {
		title: "Operazione completata correttamente!",
		subtitle: "Il tuo Streamlabs ID è stato creato e il tuo account {company} è connesso.",
		text: "Puoi utilizzare il tuo Streamlabs ID per tutti i prodotti Streamlabs. Se disponi di account esistenti, puoi connetterli a questo ID da ciascuna app.",
		button: "Chiudi"
	},
	error: {
		user: "Identificazione utente non riuscita. Riprova o contatta l'assistenza."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Il tuo ID ha già un account {company} collegato",
		subtitle: "Vuoi scollegare l'account collegato e collegarlo al tuo account Streamlabs attuale?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Potrai accedere a Streamlabs con l’e-mail e la password fornite tramite Streamlabs ID.",
			"Puoi accedere a tutti gli altri prodotti da Streamlabs con il tuo ID e connettere altri account esistenti, se ne sei in possesso.",
			"Questa modifica non influirà sul tuo account Streamlabs."
		],
		button: "Conferma",
		cancel: "Annulla",
		switchAccount: "Cambia account",
		success: "Connessione in corso...",
		agreeLabel: "Sono consapevole che, effettuando questa connessione, perderò l'accesso all'account {company} esistente associato a Streamlabs ID."
	},
	confirmed: {
		title: "Operazione completata correttamente!",
		subtitle: "Il tuo Streamlabs ID è stato creato e il tuo account {company} è connesso.",
		text: "Puoi utilizzare il tuo Streamlabs ID per tutti i prodotti Streamlabs. Se disponi di account esistenti, puoi connetterli a questo ID da ciascuna app.",
		button: "Chiudi"
	},
	error: {
		user: "Identificazione utente non riuscita. Riprova o contatta l'assistenza."
	}
};
var loginCard = {
	title: "Accedi",
	lead: "Accedi a <company>{company}</company> con <id>Streamlabs ID</id>",
	accountExists: "Sembra che tu sia in possesso di uno <b>Streamlabs ID</b>. Prova ad accedere con il tuo indirizzo e-mail.",
	forgotPassword: "Hai dimenticato la password?",
	successText: "Operazione completata correttamente! Reindirizzamento in corso...",
	signInTitle: "Accedi con una piattaforma"
};
var loginSourcesCard = {
	title: "Accedi",
	lead: "Accedi con e-mail/password",
	withSlId: "Accedi con Streamlabs ID",
	noAccountMessage: "Non vediamo un account associato a questo metodo di accesso. Prova a utilizzare un altro metodo di accesso o <signup>Iscriviti</signup> se non l’hai ancora fatto.",
	accountExistsMessage: "Il tuo indirizzo e-mail Twitch è già associato a uno Streamlabs. Prova ad accedere con il tuo indirizzo e-mail e la tua password Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mail",
	codePlaceholder: "Codice e-mail a 6-8 cifre",
	tfaCodePlaceholder: "Codice autenticatore a 2 fattori",
	newPasswordPlaceholder: "Nuova password",
	tfaError: "Il codice di reset deve essere compreso tra 6 e 10 caratteri",
	next: "Hai ricevuto il codice?",
	back: "Torna a Password dimenticata",
	buttonText: "Modifica password",
	successText: "Reimpostazione password riuscita",
	create: {
		back: "Torna all'inizio",
		buttonText: "Imposta password",
		successText: "Password impostata correttamente"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Password corrente",
	newPasswordPlaceholder: "Nuova password",
	newPasswordConfirmationPlaceholder: "Conferma nuova password",
	buttonText: "Modifica password",
	successText: "Password aggiornata correttamente",
	newPasswordConfirmationError: "Le nuove password non corrispondono",
	back: "Torna al dashboard"
};
var changePasswordCard = {
	title: "Cambia password",
	lead: "Inserisci la password corrente e una nuova password qui sotto.",
	successText: "Password aggiornata correttamente"
};
var removeTfaForm = {
	tfaCodePlaceholder: "Codice di autenticazione a 6 cifre/codice di backup a 8 cifre",
	successText: "Autenticazione a 2 fattori rimossa correttamente",
	removeBtn: "Conferma e rimuovi"
};
var removeTfaCard = {
	title: "Rimuovi l’autenticazione a due fattori",
	lead: "Inserisci un codice di conferma di autenticazione a 2 fattori qui sotto per rimuovere l'autenticazione a 2 fattori dal tuo account.",
	successText: "Autenticazione a 2 fattori rimossa correttamente",
	back: "Torna al dashboard"
};
var verifyEmailForm = {
	codePlaceholder: "Codice a 8 cifre dell'e-mail",
	tfaCodePlaceholder: "Codice autenticatore a 2 fattori",
	emailPlaceholder: "Indirizzo e-mail",
	buttonText: "Verifica e-mail",
	successText: "E-mail verificata correttamente",
	requestBtn: "Richiedi nuovo codice",
	requestingBtn: "Richiesta in corso...",
	requestSuccess: "È stato inviato un codice alla tua e-mail",
	requestAgain: "Richiedi di nuovo tra {seconds}s",
	tfaError: "Il codice di reset deve essere compreso tra 6 e 10 caratteri",
	back: "Indietro"
};
var signupCard = {
	title: "Iscriviti",
	lead: "Crea un account <id>Streamlabs ID</id> da utilizzare <company>{company}</company>",
	successText: "Operazione completata correttamente! Reindirizzamento in corso..."
};
var signupSourcesCard = {
	title: "Iscriviti",
	lead: "Crea un account <id>Streamlabs ID</id> da utilizzare <company>{company}</company>",
	withSlId: "Crea uno Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Scegli un account",
		lead: "per continuare su <b>{company}</b>",
		authorize: "Autorizza",
		authorizeSuccess: "Operazione completata correttamente!",
		cancel: "Annulla",
		disclaimer: {
			streamlabs: "Se continui, il tuo Streamlabs ID (nome, indirizzo e-mail, lingua preferita e l'immagine del profilo) verrà condiviso con <b>{company}</b>. Autorizzando un account con <b>{company}</b>, accetti l’<privacy>Informativa sulla privacy</privacy> e i <terms>Termini del servizio</terms> di <b>{company}</b>.",
			"default": "Per continuare, Streamlabs condividerà il nome, l'indirizzo e-mail, la lingua preferita e l'immagine del profilo con <b>{company}</b>. Autorizzando un account con <b>{company}</b>, accetti l’<privacy>Informativa sulla privacy</privacy> e i <terms>Termini del servizio</terms> di <b>{company}</b>."
		},
		emailRequired: "È richiesta la verifica dell'e-mail per procedere",
		tfaRequired: "Per procedere è richiesta l'autenticazione a 2 fattori"
	},
	login: {
		title: "Accedi {company}",
		lead: "Per collegare gli account devi aver effettuato l’accesso",
		loginBtn: "Procedi all'accesso"
	},
	error: {
		title: "Accedi {company}",
		lead: "La richiesta non può essere autorizzata in questo momento.",
		verifyEmail: "Verifica e-mail",
		verify2fa: "Verifica autenticazione a due fattori"
	},
	"switch": {
		btn: "Utilizza un altro account"
	}
};
var appsDropdown = {
	label: "Prodotti e app Streamlabs",
	viewMore: "Espandi",
	viewLess: "Comprimi"
};
var platformButtons = {
	loginWithPlatform: "Accedi con una piattaforma",
	signUpWithPlatform: "Iscriviti con una piattaforma",
	signUpLead: "Supportiamo il live streaming su molte altre piattaforme, queste sono solo le opzioni di iscrizione."
};
var ultraCheckoutCard = {
	title: "Migliora i tuoi live stream, il branding, l'editing e molto altro ancora con <b>Streamlabs Ultra</b>",
	badge: "Include <b>{planName}</b>",
	totalValue: "Valore {price, currency}",
	price: {
		month: "{price, currency}/mese",
		year: "{price, currency}/anno"
	},
	description: {
		month: "Accedi alle funzioni premium dell'intera suite, tra cui <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e molto altro ancora, disponibile a un prezzo conveniente.",
		year: "Accedi alle funzioni premium dell'intera suite, tra cui <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e molto altro ancora, disponibile a un prezzo conveniente."
	},
	seeIncluded: "Scopri di più",
	buyNow: "Esegui l’upgrade"
};
var ultraCheckoutBanner = {
	title: "Migliora i tuoi live stream, il branding, l'editing e molto altro ancora con <b>Streamlabs Ultra</b>",
	badge: "Include <b>{planName}</b>",
	totalValue: "Valore {price, currency}",
	price: {
		month: "{price, currency}/mese",
		year: "{price, currency}/anno"
	},
	description: {
		month: "Accedi alle funzioni premium dell'intera suite, tra cui <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e molto altro ancora, disponibile a un prezzo conveniente. <link />",
		year: "Accedi alle funzioni premium dell'intera suite, tra cui <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> e molto altro ancora, disponibile a un prezzo conveniente. <link />"
	},
	seeIncluded: "Scopri di più",
	buyNow: "Esegui l’upgrade"
};
var connect = {
	waitMessage: "Unione dei dati in corso. Non chiudere questa finestra."
};
var verifyPasswordCard = {
	success: "Password verificata con successo",
	title: "Effettua nuovamente l'autenticazione per verificare",
	lead: "Accedi con l'e-mail e la password esistenti per continuare ad aggiornare il tuo Streamlabs ID.",
	buttonText: "Avanti"
};
var emailChangeForm = {
	agreeError: "Verifica di aver compreso questa azione",
	buttonText: "Avanti",
	emailPlaceholder: "Nuovo indirizzo e-mail",
	agreeText: "Sono consapevole che una volta verificato, il mio Streamlabs ID cambierà in tutti i prodotti Streamlabs a cui è collegato."
};
var verifyNewEmailCard = {
	title: "Cambia il tuo Streamlabs ID",
	lead: "Fornisci un nuovo indirizzo e-mail da utilizzare come Streamlabs ID. Invieremo un codice di verifica di 6-8 cifre a questo indirizzo.",
	successText: "Nuova e-mail disponibile"
};
var verifyNewEmailOwnershipCard = {
	title: "Verifica il tuo Streamlabs ID aggiornato",
	lead: "Controlla il codice a 8 cifre ricevuto via e-mail da Streamlabs e inseriscilo qui sotto.",
	buttonText: "Conferma",
	back: "Indietro",
	codePlaceholder: "Codice a 8 cifre dell'e-mail",
	successText: "La proprietà dell'e-mail è stata verificata con successo"
};
var verifyTfaCard = {
	title: "Codice di autenticazione a 2 fattori",
	lead: "Inserisci il codice di verifica di 6 cifre dalla tua app di autenticazione.",
	codePlaceholder: "Codice a 6 cifre",
	buttonText: "Conferma",
	successText: "Autenticazione a 2 fattori confermata",
	back: "Indietro"
};
var ageGateForm = {
	ageLabel: "Data di nascita",
	agePlaceholder: "MM/GG/AAAA"
};
var ageGateCard = {
	title: "Configurazione completa dell'account",
	lead: {
		years: "Per creare un account devi avere almeno {years}. <br />Inserisci la tua data di nascita per completare la configurazione.",
		noYears: "Per creare un account devi fornire la tua data di nascita. <br />Inseriscila per completare l'impostazione."
	},
	successText: "Congratulazioni! Configurazione dell'account completata."
};
var itIT = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { itIT as i };
//# sourceMappingURL=it-IT.es.js.map
